import { styled } from '../../../lib/stitches'

const Line = styled('div', {
  position: 'relative',
  width: '100%',
  height: '1.5px',
  borderRadius: '2px',
  transition: '0.2s',
  backgroundColor: '$black'
})

const InsideLine = styled('div', {
  position: 'absolute',
  display: 'flex',
  top: 0,
  left: 0,
  width: '100%',
  height: '1.5px',
  borderRadius: '2px',
  transition: '0.5s',
  backgroundColor: '$black'
})

const HamburgerWrapper = styled('div', {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '24px',
  height: '24px',
  cursor: 'pointer',
  transition: '0.5s',
  '&.active': {
    transform: 'rotate(225deg)'
  },

  '&.active > div': {
    background: 'inherit',
    '> div:nth-child(1)': {
      transform: 'rotate(90deg)',
      backgroundColor: '$gray01'
    },

    '> div:nth-child(2)': {
      transform: 'rotate(0deg)',
      backgroundColor: '$gray01'
    }
  },

  '@tablet': {
    display: 'none'
  }
})

const Hamburger = ({ onClick, isActive }: { onClick: () => void; isActive: boolean }) => {
  return (
    <HamburgerWrapper onClick={onClick} className={`${isActive && 'active'}`}>
      <Line>
        <InsideLine
          css={{
            transform: 'translateY(-5.5px)'
          }}
        />
        <InsideLine
          css={{
            transform: 'translateY(5.5px)'
          }}
        />
      </Line>
    </HamburgerWrapper>
  )
}

export default Hamburger
